import React from "react";
import Slider from "src/components/slider";
import dateformat from "dateformat";
import DOMPurify from "dompurify";

import { NDAConsent } from "src/types/conversations";

import _ from "lodash";
import styles from "./NDAconsent.module.scss";

interface INDADetail {
  consent: {
    show: boolean;
    content: NDAConsent | null;
  };
  onClose: () => void;
}

const NDADetail: React.FC<INDADetail> = ({ consent, onClose }) => {
  return (
    <Slider.Dialog
      show={consent.show}
      width="400px"
      onClose={onClose}
      className={styles.container}
    >
      <Slider.Header className={styles.header}>
        <span className={styles.titleContainer}>
          <strong className={styles.title}>signed</strong>
          <i className="paperflite-close" onClick={onClose}></i>
        </span>
        <p className={styles.subTitle}>
          on {dateformat(consent.content?.consentedDate, 'dd mmm yyyy')}
        </p>
      </Slider.Header>
      <Slider.Body className={styles.content}>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              _.get(consent, "content.description", ""),
            ),
          }}
        />
      </Slider.Body>
    </Slider.Dialog>
  );
};

export default NDADetail;
